import _ from 'lodash';

import { featureRoute } from '../helpers';
import OpenGolfActions from '../../actions/OpenGolfActions';

import { Widgets } from '../../constants/AppConstants';

module.exports = featureRoute('enableOpenGolf', Widgets.OPEN_GOLF_TICKET_SELECTION, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/widget/openTicketSelection/OpenTicketSelection').default);
        }, 'open-golf-ticket-selection');
    },

    async onEnter ({ params, location }, replace, callback) {
        await OpenGolfActions.loadFromParams(params, location.query);
        _.defer(callback);
    }
});



// WEBPACK FOOTER //
// ./src/routes/Widget/OpenGolfTicketSelection.js